<template>
    <div class="container">
        <div v-bind:class="{ breadcrumb: module === 'booking',  breadcrumb_srvcs: module === 'services',  breadcrumb_rebooking: module === 'rebooking' }">
            <a v-bind:class="{ active: active_item === 'first' }">
                <span class="breadcrumb__inner" v-if="module === 'booking'">
                    <span class="breadcrumb__title">{{ bc_firstitem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 1</span>
                </span>
                <span class="breadcrumb__inner" v-if="module === 'services' && get_areWeInServicesBookingNoMode === false">
                    <span class="breadcrumb__title">{{ srvcs_firstitem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 1</span>
                </span>
                <span class="breadcrumb__inner" v-if="module === 'services' && get_areWeInServicesBookingNoMode === true">
                    <span class="breadcrumb__title">{{ srvcsbookingno_firstitem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 1</span>
                </span>
                <span class="breadcrumb__inner" v-if="module === 'rebooking'">
                    <span class="breadcrumb__title">{{ rebooking_firstitem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 1</span>
                </span>
            </a>

            <a v-bind:class="{ active: active_item === 'second' }">
                <span class="breadcrumb__inner">
                    <span class="breadcrumb__title">{{ bc_seconditem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 2</span>
                </span>
            </a>

            <a  v-bind:class="{ active: active_item === 'third' }">
                <span class="breadcrumb__inner" v-if="module !== 'rebooking'">
                    <span class="breadcrumb__title">{{ bc_thirditem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 3</span>
                </span>
                <span class="breadcrumb__inner" v-if="module === 'rebooking'">
                    <span class="breadcrumb__title">{{ rebooking_thirditem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 3</span>
                </span>
            </a>

            <a  v-bind:class="{ active: active_item === 'fourth' }">
                <span class="breadcrumb__inner" v-if="module !== 'rebooking'">
                    <span class="breadcrumb__title">{{ bc_fourthitem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 4</span>
                </span>
                <span class="breadcrumb__inner" v-if="module === 'rebooking'">
                    <span class="breadcrumb__title">{{ rebooking_fourthitem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 4</span>
                </span>
            </a>

            <a v-bind:class="{ active: active_item === 'fifth' }">
                <span class="breadcrumb__inner" v-if="module !== 'rebooking'">
                    <span class="breadcrumb__title">{{ bc_fifthitem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 5</span>
                </span>
                <span class="breadcrumb__inner" v-if="module === 'rebooking'">
                    <span class="breadcrumb__title">{{ rebooking_fifthitem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 5</span>
                </span>
            </a>

            <a v-bind:class="{ active: active_item === 'sixth' }" v-if="module === 'rebooking'">
                <span class="breadcrumb__inner">
                    <span class="breadcrumb__title">{{ rebooking_sixthitem[getCurrentLocale] }}</span>
                    <span class="breadcrumb__desc">{{ step[getCurrentLocale] }} 6</span>
                </span>
            </a>

        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['active_item', 'module'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                bc_firstitem: {
                    en: 'Flightsearch',
                    de: 'Flugsuche',
                },
                srvcs_firstitem: {
                    en: 'Your Flight(s)',
                    de: 'Ihr Flug/Flüge',
                },
                srvcsbookingno_firstitem: {
                    en: 'Your Booking',
                    de: 'Ihre Buchung',
                },
                bc_seconditem: {
                    en: 'Passenger(s)',
                    de: 'Passagier(e)',
                },
                bc_thirditem: {
                    en: 'Payment',
                    de: 'Zahlung',
                },
                bc_fourthitem: {
                    en: 'Overview',
                    de: 'Übersicht',
                },
                bc_fifthitem: {
                    en: 'Confirmation',
                    de: 'Bestätigung',
                },
                step: {
                    en: 'Step',
                    de: 'Schritt',
                },
                // >>> ------------------------------------
                rebooking_firstitem: {
                    en: 'Your Booking(s)',
                    de: 'Ihre Buchung(en)',
                },
                rebooking_thirditem: {
                    en: 'New Flight(s)',
                    de: 'Neuer Flug/Flüge',
                },
                rebooking_fourthitem: {
                    en: 'Payment',
                    de: 'Zahlung',
                },
                rebooking_fifthitem: {
                    en: 'Overview',
                    de: 'Übersicht',
                },
                rebooking_sixthitem: {
                    en: 'Confirmation',
                    de: 'Bestätigung',
                }
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_areWeInServicesBookingNoMode',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html, body {
        height: 100%;
        background-color: #333;
    }

    .container {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        min-width: 480px;
        padding: 20px 15px;
    }

    .breadcrumb {
        display: flex;
        border-radius: 6px;
        overflow: hidden;
        margin: auto;
        text-align: center;
        top: 50%;
        width: 100%;
        height: 57px;
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
        xbox-shadow: 0 1px 1px black, 0 4px 14px rgba(0, 0, 0, 0.7);
        z-index: 1;
        background-color: #D9D9D8;
        font-size: 14px;
    }



    /* >>> ------------------------------------------------------------------ */
    .breadcrumb a {
        position: relative;
        display: flex;
        flex-grow: 1;
        text-decoration: none;
        margin: auto;
        height: 100%;
        padding-left: 38px;
        padding-right: 0;
        color: #9F9F9E; /* 2D3E5A */
    }

    .breadcrumb a:first-child {
        padding-left: 15.2px;
    }

    .breadcrumb a:last-child {
        padding-right: 15.2px;
    }

    .breadcrumb a:after {
        content: "";
        position: absolute;
        display: inline-block;
        width: 57px;
        height: 57px;
        top: 0;
        right: -28.1481481481px;
        background-color: #D9D9D8;
        border-top-right-radius: 5px;
        -webkit-transform: scale(0.707) rotate(45deg);
                transform: scale(0.707) rotate(45deg);
        box-shadow: 1px -1px rgba(0, 0, 0, 0.25);
        z-index: 1;
    }

    .breadcrumb a:last-child:after {
        content: none;
    }

    .breadcrumb a.active {
        background: #ec008b;
        color: white;
    }

    .breadcrumb a.active:after {
        background: #ec008b;
        color: white;
    }






    /* >>> ------------------------------------------------------------------ */
    .breadcrumb_srvcs {
        display: flex;
        border-radius: 6px;
        overflow: hidden;
        margin: auto;
        text-align: center;
        top: 50%;
        width: 100%;
        height: 57px;
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
        xbox-shadow: 0 1px 1px black, 0 4px 14px rgba(0, 0, 0, 0.7);
        z-index: 1;
        background-color: #D9D9D8;
        font-size: 14px;
    }

    .breadcrumb_srvcs a {
        position: relative;
        display: flex;
        flex-grow: 1;
        text-decoration: none;
        margin: auto;
        height: 100%;
        padding-left: 38px;
        padding-right: 0;
        color: #9F9F9E; /* 2D3E5A */
    }

    .breadcrumb_srvcs a:first-child {
        padding-left: 15.2px;
    }

    .breadcrumb_srvcs a:last-child {
        padding-right: 15.2px;
    }

    .breadcrumb_srvcs a:after {
        content: "";
        position: absolute;
        display: inline-block;
        width: 57px;
        height: 57px;
        top: 0;
        right: -28.1481481481px;
        background-color: #D9D9D8;
        border-top-right-radius: 5px;
        -webkit-transform: scale(0.707) rotate(45deg);
                transform: scale(0.707) rotate(45deg);
        box-shadow: 1px -1px rgba(0, 0, 0, 0.25);
        z-index: 1;
    }

    .breadcrumb_srvcs a:last-child:after {
        content: none;
    }

    .breadcrumb_srvcs a.active {
        background: #4A6E89;
        color: white;
    }

    .breadcrumb_srvcs a.active:after {
        background: #4A6E89;
        color: white;
    }



    /* >>> ------------------------------------------------------------------ */
    .breadcrumb_rebooking {
        display: flex;
        border-radius: 6px;
        overflow: hidden;
        margin: auto;
        text-align: center;
        top: 50%;
        width: 100%;
        height: 57px;
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
        xbox-shadow: 0 1px 1px black, 0 4px 14px rgba(0, 0, 0, 0.7);
        z-index: 1;
        background-color: #D9D9D8;
        font-size: 14px;
    }

    .breadcrumb_rebooking a {
        position: relative;
        display: flex;
        flex-grow: 1;
        text-decoration: none;
        margin: auto;
        height: 100%;
        padding-left: 38px;
        padding-right: 0;
        color: #9F9F9E; /* 2D3E5A */
    }

    .breadcrumb_rebooking a:first-child {
        padding-left: 15.2px;
    }

    .breadcrumb_rebooking a:last-child {
        padding-right: 15.2px;
    }

    .breadcrumb_rebooking a:after {
        content: "";
        position: absolute;
        display: inline-block;
        width: 57px;
        height: 57px;
        top: 0;
        right: -28.1481481481px;
        background-color: #D9D9D8;
        border-top-right-radius: 5px;
        -webkit-transform: scale(0.707) rotate(45deg);
                transform: scale(0.707) rotate(45deg);
        box-shadow: 1px -1px rgba(0, 0, 0, 0.25);
        z-index: 1;
    }

    .breadcrumb_rebooking a:last-child:after {
        content: none;
    }

    .breadcrumb_rebooking a.active {
        background: #FDB714;
        color: white;
    }

    .breadcrumb_rebooking a.active:after {
        background: #FDB714;
        color: white;
    }



    /* >>> ------------------------------------------------------------------ */
    .breadcrumb__inner {
        display: flex;
        flex-direction: column;
        margin: auto;
        z-index: 2;
    }
    .breadcrumb__title {
        font-weight: bold;
        font-size: 12px;
        letter-spacing: 0.48px;
        text-transform: uppercase;
    }
    .breadcrumb__desc {
        font-weight: bold;
        font-size: 10px;
        letter-spacing: 0.48px;
        text-transform: uppercase;
    }



    /* >>> ------------------------------------------------------------------ */
    @media all and (max-width: 1000px) {
        .breadcrumb {
            font-size: 12px;
        }
        .breadcrumb_srvcs {
            font-size: 12px;
        }
    }
    @media all and (max-width: 710px) {
        .breadcrumb__desc {
            display: none;
        }

        .breadcrumb {
            height: 38px;
        }

        .breadcrumb a {
            padding-left: 25.3333333333px;
        }

        .breadcrumb a:after {
            content: "";
            width: 38px;
            height: 38px;
            right: -19px;
            -webkit-transform: scale(0.707) rotate(45deg);
                    transform: scale(0.707) rotate(45deg);
        }


        .breadcrumb_srvcs {
            height: 38px;
        }

        .breadcrumb_srvcs a {
            padding-left: 25.3333333333px;
        }

        .breadcrumb_srvcs a:after {
            content: "";
            width: 38px;
            height: 38px;
            right: -19px;
            -webkit-transform: scale(0.707) rotate(45deg);
                    transform: scale(0.707) rotate(45deg);
        }

    }

    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        .breadcrumb__title {
            font-size: 11px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/breadcrumbs/Breadcrumbs.vue